module.exports = __webpack_public_path__ + "static/media/CarMain.fe42d9b2.png";